import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import {
    sendHoverSoundCommand,
    sendClickSoundCommand,
} from 'react-wot-bootstrap'

import { ARROW_SIZES, ARROW_TYPES } from './constants'

import styles from './NavigationArrow.scss'

export const NavigationArrow = (props) => {
    const className = classNames(
        styles.base,
        styles[`base__${props.size}`],
        styles[`base__${props.type}`],
        {
            [styles.base__disabled]: props.disabled,
            [styles.noBorder]: props.hideBorder,
        }
    )

    return (
        <button
            className={className}
            onClick={props.disabled ? null : props.handleClick}
            onMouseDown={props.disabled ? null : sendClickSoundCommand}
            onMouseEnter={props.disabled ? null : sendHoverSoundCommand}
        >
            <span className={styles.arrow}></span>
        </button>
    )
}

NavigationArrow.propTypes = {
    size: PropTypes.oneOf(Object.values(ARROW_SIZES)).isRequired,
    type: PropTypes.oneOf(Object.values(ARROW_TYPES)).isRequired,
    disabled: PropTypes.bool,
    handleClick: PropTypes.func,
    hideBorder: PropTypes.bool,
}

NavigationArrow.SIZES = ARROW_SIZES
NavigationArrow.TYPES = ARROW_TYPES

NavigationArrow.defaultProps = {
    size: ARROW_SIZES.big,
}

export default NavigationArrow



// WEBPACK FOOTER //
// ./components/NavigationArrow/NavigationArrow.jsx